import { render, staticRenderFns } from "./add-authorize.vue?vue&type=template&id=40fb2d93&scoped=true&"
import script from "./add-authorize.vue?vue&type=script&lang=js&"
export * from "./add-authorize.vue?vue&type=script&lang=js&"
import style0 from "./add-authorize.vue?vue&type=style&index=0&id=40fb2d93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb2d93",
  null
  
)

export default component.exports